import React, { useReducer } from 'react';
import { Container, CssBaseline, ThemeProvider } from '@material-ui/core';
import styled from 'styled-components';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { newBuSTheme } from './styles/theme';
import ProgressBar from './components/ProgressBar';
import { appReducer, initialAppState } from './reducers/appReducer';
import ResultCard from './components/views/ResultCard';
import { getProgress } from './utils/progressUtils';
import QuestionCard from './components/views/QuestionCard';
import ResultBreakdownCard from './components/views/ResultBreakdownCard/ResultBreakdownCard';
import FeedbackCard from './components/views/FeedbackCard';
import TopLevelErrorBoundary from './components/errorHandlers/TopLevelErrorBoundary';

const App = () => {
  const [state, dispatch] = useReducer(appReducer, initialAppState);

  return (
    <TopLevelErrorBoundary>
      <ThemeProvider theme={newBuSTheme}>
        <CssBaseline />
        <div className="App">
          <Router>
            <Switch>
              <Route exact path="/">
                <Redirect to="/question/0" />
              </Route>
              <Route path="/question/:id">
                <AppContainer>
                  <ProgressBar progress={getProgress(state)} />
                  <QuestionCard state={state} dispatch={dispatch} />
                </AppContainer>
              </Route>
              <Route exact path="/results">
                <AppContainer>
                  <ProgressBar progress={100} />
                  <ResultCard state={state} />
                </AppContainer>
              </Route>
              <Route exact path="/feedback">
                <AppContainer>
                  <ProgressBar progress={100} />
                  <FeedbackCard />
                </AppContainer>
              </Route>
              <Route path="/results/:id">
                <ResultBreakdownCard />
              </Route>
              <Route path="*">
                <p>Page not found</p>
              </Route>
            </Switch>
          </Router>
        </div>
      </ThemeProvider>
    </TopLevelErrorBoundary>
  );
};

const AppContainer = styled(Container)`
  width: 762px; // set to 100% for prod?
  @media (max-width: 450px) {
    width: 375px;
  }
`;

export default App;
